"use strict";import{SliderHandle as e}from"./src/SliderHandle.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-slider-handle",e);
//# sourceMappingURL=sp-slider-handle.js.map
